import React from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import { format } from "date-fns";

const axisStyle = { fill: "#71717a", fontSize: 10, fontFamily: "JetBrains Mono, monospace" };

function fmtTime(t) {
  try { return format(new Date(t), "HH:mm"); } catch { return t; }
}

function CustomTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="panel px-3 py-2 text-xs font-mono-tech">
      <div className="label-tech mb-1">{format(new Date(label), "dd MMM · HH:mm:ss")}</div>
      {payload.map((p) => (
        <div key={p.dataKey} className="flex items-center gap-2">
          <span className="w-2 h-2" style={{ background: p.color }} />
          <span className="text-zinc-400">{p.name}</span>
          <span className="text-white ml-auto">{Number(p.value).toFixed(2)}</span>
        </div>
      ))}
    </div>
  );
}

export default function TrendChart({ data }) {
  return (
    <section className="panel p-5" data-testid="trend-chart">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-heading font-semibold text-base tracking-tight">POWER TREND</h3>
          <div className="label-tech mt-1">kW / kVA / kVAR over selected range</div>
        </div>
      </div>
      <div className="h-[260px]">
        <ResponsiveContainer width="100%" height="100%" minHeight={300}>
          <LineChart data={data} margin={{ top: 5, right: 16, left: 0, bottom: 0 }}>
            <CartesianGrid stroke="rgba(255,255,255,0.05)" strokeDasharray="0" />
            <XAxis dataKey="Time" tickFormatter={fmtTime} tick={axisStyle} stroke="#3f3f46" />
            <YAxis tick={axisStyle} stroke="#3f3f46" />
            <Tooltip content={<CustomTooltip />} />
            <Legend wrapperStyle={{ fontSize: 10, fontFamily: "JetBrains Mono, monospace", color: "#a1a1aa" }} />
            <Line type="monotone" dataKey="ttl_kw" name="kW" stroke="#3b82f6" strokeWidth={1.5} dot={false} isAnimationActive={false} />
            <Line type="monotone" dataKey="ttl_kva" name="kVA" stroke="#facc15" strokeWidth={1.5} dot={false} isAnimationActive={false} />
            <Line type="monotone" dataKey="ttl_kvar" name="kVAR" stroke="#ef4444" strokeWidth={1.5} dot={false} isAnimationActive={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </section>
  );
}
